// Shared modifier constants used by WhatIfEditor and ComparePage.
// Extracted alongside the WhatIfEditor split (v221) so both files
// reference the same source of truth — adding a new factor only needs
// updating this one place.

export const MODIFIER_LABELS = {
  governance: 'Governance Maturity',
  change_readiness: 'Change Readiness',
  content_readiness: 'Content Readiness',
  integration_complexity: 'Integration Complexity',
  org_complexity: 'Organizational Complexity',
  timeline_pressure: 'Timeline Pressure',
  client_capability: 'Client Team Capability',
};

export const READINESS_KEYS = ['governance', 'content_readiness', 'client_capability', 'change_readiness'];
export const COMPLEXITY_KEYS = ['integration_complexity', 'org_complexity', 'timeline_pressure'];

export const READINESS_LABELS = ['Very Weak', 'Weak', 'Neutral', 'Strong', 'Very Strong'];
export const READINESS_VALUES = [1.4, 1.2, 1.0, 0.9, 0.8];

export const COMPLEXITY_LABELS = ['Low', 'Moderate', 'Average', 'High', 'Very High'];
export const COMPLEXITY_VALUES = [0.8, 0.9, 1.0, 1.2, 1.4];
